import React, { useContext, useState } from 'react'
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider'
import { OrderDataProviderContext } from '../../context-api/data-provider/OrderDataProvider'
import { Dialog, Snackbar } from '@mui/material'
import AtomicButton from '../../atomic/button/Button'
import { isMobile, isIpad, isDesktop } from '../../utils/ScreenSizeHelper';
import './dashboard.scss'

const CancelOrder = () => {


    const {
        isLoggedIn,
        selectedMenuTab,
        setSelectedMenuTab,
        setisLoggedIn, newPendingOrder, setNewPendingOrder,
        preparingOrder, setPreparingOrder,
        scheduledOrder, setScheduledOrder,
        openOrderAlert, setOpenOrderAlert,
        allOrders, setAllOrders,
        openUpdateTimeDialog, setOpenUpdateTimeDialog,
        openSnackBar, setOpenSnackBar,
        openCancelOrderDialog, setOpenCancelOrderDialog

    } = useContext(GlobalStateDataContext)



    const { vertical, horizontal, open } = openSnackBar;

    const { onUpdateOrderStatus,
        updateOrderAPIResponse,
        setUpdateOrderAPIResponse,
        getOrderAPIResponse,
        FetchOrders,
        clickedOrder,
        setClickedOrder } = useContext(OrderDataProviderContext)

    const { loading, success, message, data, } = getOrderAPIResponse
    const { loading: isLoading, success: isSucess, message: isMessage, data: isData } = updateOrderAPIResponse

    const handleClose = (event, reason) => {
        setOpenSnackBar({
            ...openSnackBar,
            warning: false,
            open: false,
            snakBarMessage: ''
        });

        if (reason === 'clickaway') {
            return;
        }

    };


    const handleCancelOrderSubmit = async () => {


        const payload = {
            order_no: clickedOrder?.order_no,
            user_type: "kitchen",
            operation: "cancel order",
        }

        setOpenSnackBar({
            ...openSnackBar,
            warning: false
        });

        const checkResp = await onUpdateOrderStatus(payload)

        if (checkResp?.success && checkResp?.message === "Order cancelled successfully!") {
            setOpenSnackBar({
                ...openSnackBar,
                open: true,
                warning: false,
                snakBarMessage: "Order canceled successfully"
            });
            // Accept order
            FetchOrders()
            setClickedOrder({})
            setOpenCancelOrderDialog(false)

        } else {
            setOpenSnackBar({
                ...openSnackBar,
                open: true,
                warning: true,
                snakBarMessage: "Cancellation is not allowed at the current stage"
            });
            setOpenCancelOrderDialog(false)
        }

    }



    return (
        <>
            <Dialog
                open={openCancelOrderDialog}
                // onClose={handleClose}  // This will close dialog if it clicked anywhere on screen
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="alert-dialog-wrapper"
            >

                <div style={{
                    display: 'flex',
                    // justifyContent: 'center',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minWidth: 'calc(90vw - 0px)',
                    marginTop: '5%',
                    // overflowY: 'none',
                    // height: '80%',
                    height: '200px'
                }}>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        marginBottom: '20px'
                    }}>
                        <a style={{
                            fontFamily: 'Inter Bold',
                            marginBottom: '5px',
                            letterSpacing: '0.5px'
                        }}> Confirm Order Cancellation</a>
                        <a style={{
                            fontFamily: 'Inter Regular',
                            letterSpacing: '0.5px'
                        }}> Once you cancel the order, it cannot be undone. A full refund will be issued to the customer</a>
                    </div>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}>

                        <AtomicButton
                            label="Cancel"
                            handleSubmit={() => { setOpenCancelOrderDialog(false); }}
                            style={{
                                backgroundColor: '#fff4e7',
                                width: "125px",
                                marginRight: '10px',
                                color: 'gray'
                            }}
                            loading={false}
                            disabled={false}
                        />
                        <AtomicButton
                            label="Proceed with Cancellation"
                            handleSubmit={handleCancelOrderSubmit}
                            style={{
                                color: 'white',
                                backgroundColor: '#FF6363',
                                width: "250px",
                                margin: '0px',
                                margin: '0px 5px 0px 10px'
                            }}
                            loading={loading || isLoading}
                            disabled={loading || isLoading}
                        />

                    </div>


                </div>


            </Dialog>

            <Snackbar
                open={open}
                anchorOrigin={{ vertical, horizontal }}
                className={openSnackBar?.warning ? 'warning-order-snackbar' : 'order-snackbar'}
                autoHideDuration={5000}
                onClose={handleClose}
                message={openSnackBar?.snakBarMessage}
            />
        </>

    )
}

export default CancelOrder